export const influenceClasses = (politician) => {
    let classes = "";
    if (politician.chinese_influence) {
        classes = "politician__influence--chinese politician__influence--chinese--" + politician.chinese_influence;
    }
    else if (politician.chinese_positive_influence) {
        classes = "politician__influence--chinese-positive politician__influence--chinese-positive--" + politician.chinese_positive_influence;
    }
    if (politician.russian_influence) {
        classes += " politician__influence--russian politician__influence--russian--" + politician.russian_influence;
    }
    else if (politician.russian_positive_influence) {
        classes += " politician__influence--russian-positive politician__influence--russian-positive--" + politician.russian_positive_influence;
    }
    return classes;
};

export const stopScrolling = () => {
    document.body.classList.add('stop-scrolling');
};

export const startScrolling = () =>
document.body.classList.remove('stop-scrolling');
